import React from 'react'

import { styled } from '@mui/material/styles'
import FONTS from '@/src/fonts'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import Table from '@mui/material/Table'
import { useMediaQuery, useTheme } from '@mui/material'
import clsx from 'clsx'

type Props = {
  columns: any
  data: any
  classNameTable?: string
  styleGridContainer?: object
  rowClassName?: string
  cellClassName?: string
}

const StyledTableCell = styled(TableCell)({
  '&.MuiTableCell-head': { fontWeight: FONTS.WEIGHT.BOLD },
})

const TableResponsive: React.FC<Props> = ({
  columns,
  data,
  classNameTable = '',
  styleGridContainer = {},
  rowClassName = '',
  cellClassName = '',
}) => {
  const theme = useTheme()
  const downSM = useMediaQuery(theme.breakpoints.down('sm'))

  return downSM ? (
    <>
      {data?.map((line, index) => (
        <div
          key={index}
          style={styleGridContainer}
          className={clsx('grid grid-cols-12', rowClassName)}
        >
          {line
            ?.filter(l => l.gridXs > 0)
            .map((row, key) => (
              <div
                className={clsx(
                  `col-span-${row.gridXs} md:col-span-${row.gridMd}`,
                  row.classNameReponsive,
                  cellClassName
                )}
                key={key}
                style={{ display: 'flex', alignItems: 'center', ...row.styleResponsive }}
              >
                {row.valueReponsive || row.value}
              </div>
            ))}
        </div>
      ))}
    </>
  ) : (
    <Table className={classNameTable} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          {columns?.map((c, index) => (
            <StyledTableCell key={index} align={c.align} className={c.className}>
              {c.title ? t({ id: c.title }) : ''}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((line, index) => (
          <TableRow key={index} hover className={rowClassName}>
            {line?.map((row, key) => (
              <StyledTableCell
                key={key}
                {...row.args}
                className={`${row.className || ''} ${cellClassName}`}
              >
                <>{row.value}</>
              </StyledTableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default TableResponsive
